import { render, staticRenderFns } from "./inventoryLoss.vue?vue&type=template&id=177d4ccb&scoped=true&"
import script from "./inventoryLoss.vue?vue&type=script&lang=js&"
export * from "./inventoryLoss.vue?vue&type=script&lang=js&"
import style0 from "./inventoryLoss.vue?vue&type=style&index=0&id=177d4ccb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177d4ccb",
  null
  
)

export default component.exports